import { Flex } from '@chakra-ui/react';
import { Heading, useNoSSRBreakpointValue } from 'ui-components';
import { IconButton } from 'ui-components/dist/Button';
import { PlusIcon } from 'ui-components/dist/PlusIcon';
import { CreatorListDrawer } from '~/components/CreatorListDrawer';
import { Feature } from '~/components/Feature';
import { FEATURE_FLAGS } from '~/constants';

import { CreateMediaKitButton } from './components/CreateMediaKitButton';
import { useSelectTalentStore } from './store/useSelectTalentStore';

interface CustomShareablesHeaderProps {
  creatorId?: string;
  onCreatorChange?: (creatorId?: string) => void;
}

export const CustomShareablesHeader: React.FC<CustomShareablesHeaderProps> = ({
  creatorId,
  onCreatorChange,
}) => {
  const isMobile = useNoSSRBreakpointValue({ base: true, md: false });
  const { setIsModalOpen } = useSelectTalentStore();

  const onAddListClicked = () => setIsModalOpen(true);

  return (
    <Flex
      alignItems="center"
      as="header"
      justifyContent="space-between"
      marginBottom={2}
      paddingBottom={4}
    >
      <Heading size="md">Media Kits</Heading>

      <Flex justifyContent="flex-end" alignItems="center" gap={2}>
        {onCreatorChange && (
          <Feature name={FEATURE_FLAGS.foamMediaKitsTalentFilter}>
            <CreatorListDrawer
              defaultSelectedCreatorId={creatorId}
              onFilter={onCreatorChange}
              showAgencyRoster={true}
              trackId="filterbar-find-creator-modal"
            />
          </Feature>
        )}

        {isMobile ? (
          <IconButton
            aria-label="Create new media kit"
            icon={<PlusIcon boxSize={4} />}
            onClick={onAddListClicked}
            size="md"
            track-id="create-new-media-kit-btn"
          />
        ) : (
          <CreateMediaKitButton
            onClick={onAddListClicked}
            trackId="create-new-media-kit-btn"
          />
        )}
      </Flex>
    </Flex>
  );
};
